import {styled} from "@mui/material";
import Text from '@components/Text';
import { getIconsByType, iconTypes } from '@services/icons';

export const Wrapper = styled('div')(
  {
    padding: '32px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    textAlign: 'center',
    minHeight: 320,
    width: 560,
    maxWidth: '90vw',
    gap: 16,
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.novotalk.$backgroundColor,
  })
);

const iconStyles = {
  margin: '0 10px',
  fontSize: 45,
};

export const StyledMicIcon = styled(getIconsByType(iconTypes.SOUND_ON))(
  iconStyles,
  {
    marginLeft: -5,
  },
  ({ theme }) => ({
    color: theme.palette.novotalk.$textColorDisabled,
  })
);

export const StyledVideoIcon = styled(getIconsByType(iconTypes.VIDEO_ON))(
  iconStyles,
  ({ theme }) => ({
    color: theme.palette.novotalk.$textColorDisabled,
  })
);

export const StyledText = styled(Text)({
  display: 'block',
  width: '100%',
  maxWidth: 480,
  marginBottom: 10,
  lineHeight: '24px',
});

export const StyledImg = styled('img')({
  marginBottom: 36,
});

export const IconsWrapper = styled('div')({
  marginBottom: 6,
  display: 'flex',
  flexShrink: 0,
  textAlign: 'center',
});
